import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { LOGO_BASE64 } from '../assets/logoData';
import './Navbar.css';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [productsOpen, setProductsOpen] = useState(false);
  const location = useLocation();
  const dropdownRef = useRef(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
    setProductsOpen(false);
  }, [location]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setProductsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="container navbar__inner">
        <Link to="/" className="navbar__logo">
          <img src={LOGO_BASE64} alt="MS Discoveries" />
        </Link>

        <ul className={`navbar__links ${menuOpen ? 'navbar__links--open' : ''}`}>
          <li><NavLink to="/" end>Home</NavLink></li>
          <li><NavLink to="/about">About</NavLink></li>
          <li className="navbar__dropdown" ref={dropdownRef}>
            <button
              className={`navbar__dropdown-trigger ${productsOpen ? 'active' : ''}`}
              onClick={() => setProductsOpen(!productsOpen)}
            >
              Products
              <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
                <path d="M1 1L6 6L11 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
            </button>
            {productsOpen && (
              <div className="navbar__dropdown-menu">
                <a href="https://mschat.msdiscoveries.com/" target="_blank" rel="noreferrer">
                  <div className="dropdown-item-text">
                    <strong>MS Chat</strong>
                    <small>Chatbot + CRM</small>
                  </div>
                </a>
                <a href="https://mark.msdiscoveries.com/" target="_blank" rel="noreferrer">
                  <div className="dropdown-item-text">
                    <strong>Email Campaign</strong>
                    <small>Email Marketing</small>
                  </div>
                </a>
                <a href="https://emailverifier.msdiscoveries.com/login" target="_blank" rel="noreferrer">
                  <div className="dropdown-item-text">
                    <strong>Email Verifier</strong>
                    <small>Email Verification</small>
                  </div>
                </a>
              </div>
            )}
          </li>
          <li><NavLink to="/blog">Blog</NavLink></li>
          <li><NavLink to="/contact">Contact</NavLink></li>
        </ul>

        <div className="navbar__cta">
          <Link to="/contact" className="btn-primary">
            <span>Get Started</span>
          </Link>
        </div>

        <button
          className={`navbar__hamburger ${menuOpen ? 'navbar__hamburger--open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {menuOpen && (
        <div className="navbar__mobile-menu">
          <ul>
            <li><NavLink to="/" end>Home</NavLink></li>
            <li><NavLink to="/about">About</NavLink></li>
            <li className="mobile-section-title">Products</li>
            <li><a href="https://mschat.msdiscoveries.com/" target="_blank" rel="noreferrer">MS Chat – Chatbot + CRM</a></li>
            <li><a href="https://mark.msdiscoveries.com/" target="_blank" rel="noreferrer">Email Campaign</a></li>
            <li><a href="https://emailverifier.msdiscoveries.com/login" target="_blank" rel="noreferrer">Email Verifier</a></li>
            <li><NavLink to="/blog">Blog</NavLink></li>
            <li><NavLink to="/contact">Contact</NavLink></li>
            <li>
              <Link to="/contact" className="btn-primary" style={{display:'inline-block', marginTop:'8px'}}>
                <span>Get Started</span>
              </Link>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
